/** Content for the Pencil infinite-canvas frames (from the "Infinite, Explained." Magic Patterns deck). */

export const pencilAds = {
  wide: 'https://cdn.magicpatterns.com/patterns/generated-images/a545766e-98f8-4703-92fc-de1e2d020252.jpg',
  story: 'https://cdn.magicpatterns.com/patterns/generated-images/458784e2-ecb6-4901-a109-08dfb4110b9a.jpg',
  square: 'https://cdn.magicpatterns.com/patterns/generated-images/68ee4911-e643-4105-90a6-bfeddcc4195c.jpg',
  landscape: 'https://cdn.magicpatterns.com/patterns/generated-images/0cf9f65c-57c9-4c4a-92ce-0553a42049f4.jpg',
};

export const pencilComments = [
  {
    initials: 'JW',
    name: 'Jenny Wen',
    time: '6 hours ago',
    text: 'I love where this is headed, but I’m not quite sure about the spacing here.',
    unread: true,
  },
  {
    initials: 'DO',
    name: 'Diego Ortiz',
    time: '5 hours ago',
    text: 'Can we try the 9:16 cut with the runner entering from the left?',
    unread: false,
  },
  {
    initials: 'AS',
    name: 'Ana Silva',
    time: '3 hours ago',
    text: 'Score jumped to 65 after the headline swap. Keeping this one.',
    unread: true,
  },
  {
    initials: 'BP',
    name: 'Ben Park',
    time: '1 hour ago',
    text: 'Legal flagged “fastest”. Swapping to “Built for the long way up.”',
    unread: false,
  },
];

export const pencilComposerText = 'Love it. Can we nudge the logo? @Jenny';

export const pencilCaptions = [
  { title: 'Comments start with one click.', body: 'Mode and panel switch together.' },
  { title: 'Say it where you see it.', body: 'Feedback anchored to the work.' },
];
